import { combineReducers } from 'redux';

import {
  getTreeViewStructure, groupData, getTreeViewDefaultValue
} from '@r/reducers/storeParts/calculationMode/utils';

import { value } from './value';
import { options } from './options';
import { searchText } from './searchText';

export const hinges = combineReducers( {
  value,
  options,
  searchText
} );

export function setDefaultHinges() {
  return ( dispatch, getStore ) => {
    const { calculationMode: { materialsFromDb } } = getStore();

    const options = getTreeViewStructure(
      groupData( materialsFromDb.Hinge, ['type'] ),
      'name'
    );

    dispatch( {
      type: 'SET_CALCULATION_MODE_ADMIN_SETTINGS_HINGES_OPTIONS',
      value: options
    } );

    dispatch( {
      type: 'SET_CALCULATION_MODE_ADMIN_SETTINGS_HINGES_VALUE',
      value: getTreeViewDefaultValue( options )
    } );
  };
}
